module.exports = __webpack_public_path__ + "img/default-profile-picture.6aadcee8.png";